import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { history } from '../../store/configureStore';

import Moment from 'react-moment';
import * as constant from '../../constants/constant';
import * as SpecialistBlogActions from '../../actions/SpecialistblogActions.js';
import autoBind from 'auto-bind';
class BlogDetails extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			blogDetailData: {},

		}
		this.goToSpecialistDetailsPage = this.goToSpecialistDetailsPage.bind(this);
	}
	componentDidMount() {
		console.log("props==>", this.props)
		let object = {
			blogId: this.props.match.params.blogId,
			type: this.props.match.params.userType,
		};
		this.props.actions.getMarketingBlogDetailsById(object)

	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.success) {
			this.setState({
				blogDetailData: nextProps.blogDetailData,
			})
		}
  }
  goToSpecialistDetailsPage( availabilitiesId) {

		history.push('/specialist-details/' + availabilitiesId);
	};
	render() {
		let blogDetailData = this.state.blogDetailData;
		// var defaultImagePath =
		// 	constant.PRODUCTION_IMAGE_URL + "uploads/common/noUserImage.jpg";
		var defaultImagePath = blogDetailData.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_m.png': constant.PRODUCTION_IMAGE_URL + 'uploads/'+ constant.COMMON_FOLDER + 'doctor_f.png' ;

		let profileImage, bannerImage
		if (blogDetailData && blogDetailData.profileImage && blogDetailData.profileImage != '' && blogDetailData.profileImage != 'noUserImage.jpg') {
			profileImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + blogDetailData.specialistId + '/' + blogDetailData.profileImage
		} else {
			profileImage = blogDetailData.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + constant.COMMON_FOLDER + 'doctor_m.png': constant.PRODUCTION_IMAGE_URL +  + 'uploads/'+ constant.COMMON_FOLDER + 'doctor_f.png' ;
		}
		if (blogDetailData && blogDetailData.bannerImage && blogDetailData.bannerImage != '' && blogDetailData.bannerImage != 'blog_dflt_l.png') {
			bannerImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + blogDetailData.specialistId + '/' + blogDetailData.bannerImage
		}	
		else{
			bannerImage = constant.PRODUCTION_IMAGE_URL + 'uploads/' + 'common' + '/' + blogDetailData.bannerImage

		}
		return (
			<div className="content-wrapper ">
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li ><Link href="#tab_1" data-toggle="tab" className="active show">Blog Details </Link></li>
									</ul>
									<div className="row">
										<div className="col-md-4 active blogBg">
											<div className="tab-content tabother searchSpe collapResults">
												<div className="tab-pane active" >
													<div className="blogDate">
														<ul><li><Moment format="DD">{blogDetailData.createdAt}</Moment></li>
															<li><p><Moment format="MMMM">{blogDetailData.createdAt}</Moment></p>
																<p><Moment format="YYYY">{blogDetailData.createdAt}</Moment></p>
															</li></ul>
																	<div className="drInfo" style={{ 'cursor': 'pointer' }} onClick={this.goToSpecialistDetailsPage.bind(this, blogDetailData.availabilitiesInfo ? blogDetailData.availabilitiesInfo[0] : '')}>
															<img src={profileImage} onError={e => {
																e.target.src = defaultImagePath;
															}} />
															<div className="drName text-capitalize" style={{ 'cursor': 'pointer' }} onClick={this.goToSpecialistDetailsPage.bind(this, blogDetailData.availabilitiesInfo ? blogDetailData.availabilitiesInfo[0] :'')}>
																{this.props.match.params.userType == 'specialist' ? 'Dr. '+ blogDetailData.userName : 'Medfix Team' }
															</div>
															<div className="drEdu">
															<p>{blogDetailData.specializationName} | {blogDetailData.gender}</p>
															<p>{blogDetailData.academics}</p><p>{blogDetailData.qualification}</p>
															</div>

														</div>

													</div>
												</div>
											</div>
										</div>
										<div className="col-md-8">
											<div className="tab-content tabother blogBg">
												<div className="row">
													<div className="col-md-12">
														{/* <ol className="breadcrumb">
    <li><Link href="">Home</Link></li>  <li><Link href="">Blog</Link></li>  <li>Lorem ipsum </li>
      </ol> */}
														<div className="blogInfo">
															<h2 className="h2Blog">{blogDetailData.blogTitle}</h2>
															<img src={bannerImage} className="blogImg" onError={e => {
																e.target.src = defaultImagePath;
															}} />
															<p dangerouslySetInnerHTML={{ __html: blogDetailData.description }}></p>
														</div>

													</div>
												</div>
											</div>
											<div className="yelbtns" ><Link className="btn btn-primary btn-signup" to="/dashboard/blog"> Back</Link></div>
										</div>

										{/* <div className="col-md-3">
                  <div className="tab-content tabother blogBg">
                    <div className="row">
                     <div className="col-sm-12">
					<div className="searchBlog">

    <i className="fa fa-search"></i>
    <input type="text" placeholder="search" />

</div>
					<div className="searchblogList"><h2>RECENT POSTS</h2>

					<ul>
						<li><Link href="#">Why mammograms could be doing you
more harm than good, By Dr. Eccles</Link></li><li><Link href="#">Why mammograms could be doing you
more harm than good, By Dr. Eccles</Link></li><li><Link href="#">Why mammograms could be doing you
more harm than good, By Dr. Eccles</Link></li><li><Link href="#">Why mammograms could be doing you
more harm than good, By Dr. Eccles</Link></li>
					</ul>
					</div>

				</div>
                    </div>
                  </div>
                </div> */}


									</div>
								</div>
							</div>
						</div>

					</div>

				</section>


			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		blogDetailData: state.SpecialistBlog.marketingBlogDetailData ? state.SpecialistBlog.marketingBlogDetailData : {},
		success: state.SpecialistBlog.marketingBlogDetailData ? state.SpecialistBlog.marketingBlogDetailData.success : false,


	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(SpecialistBlogActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(BlogDetails);
